import { Disclosure } from '@headlessui/react';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Typography } from '../../../../core/components/molecules/Typography';
import { CourseContentList } from '../CourseContent/CourseContentList';

interface AccordionContentListProps {
  contentList: any[];
  title: string;
  selectedContentId: string;
  onClickDone?: (content: any) => void;
  onCloseModal?: () => void;
  handleOpenContent: (content: any) => void;
}

function AccordionContentList({
  contentList,
  title,
  selectedContentId,
  onClickDone,
  handleOpenContent,
}: AccordionContentListProps) {
  const isSomeItemSelected = contentList.some(
    (content) => content._contentId === selectedContentId
  );
  return (
    <Disclosure defaultOpen={isSomeItemSelected}>
      {({ open }) => (
        <div>
          <Disclosure.Button className='flex w-full justify-between p-2 py-3'>
            <Typography
              type='title'
              size='h4'
              className='flex items-center gap-4'
            >
              {title}
            </Typography>
            <Icon
              type='material'
              Icon={'chevron_right'}
              className={`text-mono-color-black ${open ? 'rotate-90 transform' : ''}`}
            />
          </Disclosure.Button>

          <Disclosure.Panel>
            <CourseContentList
              contentList={contentList}
              onClickDone={onClickDone}
              handleOpenContent={handleOpenContent}
            />
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
}

export { AccordionContentList };
